// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"35241a9c","668":"9ecd1672","704":"eca111fa","954":"af6c1f8a"}[chunkId] + ".chunk.js";
};